import React from "react";
import ReactECharts from "echarts-for-react";
import '../styles.scss'
import { ChartData } from "..";
import { formatNumber } from "../../../../services/mixin";



interface Props {
    title: string;
    data: ChartData[];
    onClick?: (params: any) => void;
}

const RankPieChart: React.FC<Props> = ({
    title,
    data,
    onClick,
}) => {

    const total = data.reduce(
        (a, b) => a + b.value,
        0
    );

    const option = {

        title: {
            text: title,
            left: "left",
            top: 0,

            textStyle: {
                paddingBottom: 40,
                fontSize: 20,
                fontWeight: 600,
                color: "#344054",
                fontFamily: "SF Pro Display"

            },
        },

        tooltip: {
            trigger: "item",
            formatter: (params: any) => {

                const percent =
                    total === 0
                        ? 0
                        : (
                            params.value /
                            total *
                            100
                        ).toFixed(1);

                return `
                    ${params.name}<br/>
                    ${formatNumber(params.value)} (${percent}%)
                `;
            },
        },

        legend: {

            orient: "vertical",

            right: 10,

            top: "center",

            icon: "circle",

            itemWidth: 12,

            itemHeight: 12,

            textStyle: {

                fontSize: 16,

                color: "#344054",

            },

            formatter: (name: string) => {

                const item =
                    data.find(
                        x => x.name === name
                    );

                if (!item)
                    return name;

                const percent =
                    total === 0
                        ? 0
                        : (
                            item.value /
                            total *
                            100
                        ).toFixed(1);

                return `${name}: ${formatNumber(item.value)} (${percent}%)`;

            },

        },
        // hiển thị đầy đủ

        // series: [

        //     {

        //         type: "pie",

        //         radius: "62%",

        //         center: ["32%", "55%"],

        //         avoidLabelOverlap: true,

        //         minAngle: 2,

        //         itemStyle: {

        //             borderColor: "#fff",

        //             borderWidth: 2,

        //         },

        //         labelLine: {

        //             length: 20,

        //             length2: 30,

        //             smooth: true,

        //         },
        //         label: {

        //             formatter: (params: any) => {

        //                 const percent =
        //                     total === 0
        //                         ? 0
        //                         : (
        //                             params.value /
        //                             total *
        //                             100
        //                         ).toFixed(1);

        //                 return `${params.name}: ${params.value}\n(${percent}%)`;

        //             },

        //             fontSize: 15,

        //             color: "#344054",

        //         },

        //         data: data.map(item => ({

        //             name: item.name,

        //             value: item.value,

        //             itemStyle: {

        //                 color: item.color,

        //             },

        //         })),

        //     },

        // ],
       series: [
    {
        type: "pie",

        radius: "62%",

        center: ["32%", "55%"],

        avoidLabelOverlap: true,

        minShowLabelAngle: 5,

        labelLayout: {
            moveOverlap: "shiftY",
            hideOverlap: false
        },

        itemStyle: {
            borderColor: "#fff",
            borderWidth: 2,
        },

        labelLine: {
            length: 18,
            length2: 25,
            smooth: true
        },

        label: {
            formatter: (params: any) => {

                const percent =
                    total === 0
                        ? 0
                        : (
                            params.value /
                            total *
                            100
                        ).toFixed(1);

                return `${params.name}: ${formatNumber(params.value)}\n(${percent}%)`;
            },

            fontSize: 15,
            color: "#344054",
        },

        data: data.map(item => ({
            name: item.name,
            value: item.value,
            id: item.id,
            itemStyle: {
                color: item.color,
            },
        })),
    },
]

    };

    return (

        <div className="pie-chart-card custom-page-css flex flex-1">

            <ReactECharts

                option={option}

                style={{

                    height: 340,

                    width: "100%",

                }}


            />

        </div>

    );

};

export default RankPieChart;